export default {
  data() {
    return {
      entity: null,
      unwatches: [],
    };
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.unwatches.forEach((item) => item());
  },
  methods: {
    initChangeWatcher(entities, submit) {
      this.entities = entities;

      this.entities.forEach((item) => {
        this.unwatches.push(
          this.$watch(
            item,
            function() {
              if (this.entityChanged !== undefined) {
                this.entityChanged = true;
              } else {
                this.$emit('entity-changed', true, submit);
              }
            },
            {
              deep: true,
            }
          )
        );
      });
    },
  },
};
